import { NgIf, NgTemplateOutlet } from "@angular/common";
import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { AnalyticsService } from "@eemo/api-client";
import { ChartType, GoogleChartsModule } from "angular-google-charts";
import moment from "moment";
import { Subscription } from "rxjs";
import { ModalBaseComponent } from "../base/modal-base/modal-base.component";

export class KpiChartDialogData {
  title: string;
  historyApiFunction: string;
  historyApiField: string;
}

@Component({
  selector: "app-kpi-chart-dialog",
  templateUrl: "./kpi-chart-dialog.component.html",
  styleUrls: ["./kpi-chart-dialog.component.scss"],
  standalone: true,
  imports: [
    NgIf,
    ModalBaseComponent,
    GoogleChartsModule,
    NgTemplateOutlet,
    GoogleChartsModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
})
export class KpiChartDialogComponent implements OnInit, OnDestroy {
  dialogTitle: string;
  hasData = false;
  loading = false;

  chartType = ChartType.LineChart;

  chartData = [];
  columnNames = [];
  options = {};

  sub = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: KpiChartDialogData,
    private analyticsService: AnalyticsService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.dialogTitle = `Évolution de ${this.data.title}`;
  }
  ngOnInit(): void {
    this.loading = true;
    this.columnNames = ["Date", this.data.title];
    this.options = {
      hAxis: {
        title: "Date",
      },
      animation: {
        duration: 1000,
        easing: "out",
      },
      legend: {
        position: "top",
      },
      width: "'100%'",
      height: "600",
    };

    const today = new Date();
    const startDate = new Date(today);
    // kpi for 90 days
    startDate.setDate(today.getDate() - 90);
    this.sub = this.analyticsService[this.data.historyApiFunction](
      moment(startDate).format("YYYY-MM-DD")
    ).subscribe({
      next: (d) => {
        d.forEach((kpi) => {
          this.chartData.push([kpi.date, kpi[this.data.historyApiField]]);
        });
        this.hasData = this.chartData.length > 1;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
